import { Navigate } from "react-router-dom";
import { isTokenExpired, isAdminTokenExpired } from "../components/VerifyToken";

export function ProtectedRoute({ children }) {
  if (isTokenExpired()) {
    localStorage.removeItem("token");
    localStorage.setItem(
      "logoutReason",
      "Your session has expired. Please login again.",
    );
    return <Navigate to="/" replace />;
  }

  return children;
}

export function AdminProtectedRoute({ children }) {
  if (isAdminTokenExpired()) {
    localStorage.removeItem("token");
    localStorage.setItem(
      "logoutReason",
      "Your session has expired. Please login again.",
    );
    return <Navigate to="/admin" replace />;
  }

  return children;
}
